module.exports = __webpack_public_path__ + "static/media/kettle.31c426c4.jpg";